<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="shareDeviceForm">
		<div *ngIf="deviceVctSharing" class="flex justify-content-center">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
		<div *ngIf="!deviceVctSharing">
			<div class="grid">
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.email, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.email, 'label')">{{ 'EMAIL' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.email, 'borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-share-input-email"
								formControlName="email" autocomplete="device-email" placeholder="{{ 'EMAIL' | translate }}"
								maxlength="40" />
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.email)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyMessagesNewValidator()">{{ 'EMAIL_ADDRESS_INVALID' | translate }}</small>
				</div>
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'borderRow','notEquivalentEmail')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'label','notEquivalentEmail')">{{
							'CONFIRM_EMAIL' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'borderInput','notEquivalentEmail')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
								id="device-share-input-emailConfirm" formControlName="emailConfirm"
								autocomplete="device-emailConfirm" placeholder="{{ 'CONFIRM_EMAIL' | translate }}"
								maxlength="40" />
						</div>
					</div>
					<small *ngIf="showErrorConfirmInvalidMessage(this.f.emailConfirm,'notEquivalentEmail')"
						class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
						'EMAIL_CONFIRM_ADDRESS_INVALID' | translate }}</small>
				</div>
				<div class="col-12 flex align-items-center justify-content-center">
					<p-button label="{{ 'ASSING_TO_ME' | translate }}" icon="pi cm-user" size="large" 
						(click)="assignToMe()" [rounded]="false"
						[text]="true" severity="primary" styleClass="border-primary">
					</p-button>
				</div>
				<div class="col-12">
					<div *ngIf="this.featureId=== undefined" class="flex align-items-center justify-content-center">
						<p-checkbox formControlName="cleanup" name="cleanup" [binary]="true" styleClass="mx-2"></p-checkbox>
						<div class="text-50">{{ 'VCT_SHARE_CLEANUP' | translate }}</div>
					</div>
				</div>
			</div>

			<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
				<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
					class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
				<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
			</div>
		</div>
	</form>
</div>